var GameWatchanythingPlayerCache = {}

var GameWatchanything = React.createClass({
	mixins: [React.addons.PureRenderMixin],
	getInitialState: function () {
		window.swf = this
		window.loadLocation = this.loadLocation
		return null
	},
	render: function () {
		return (
			<div className="game-swf">
				{!this.props.room.started ? (
					<div className="game-swf-object">
						<Waiting room={this.props.room} />
						<WaitingStatus>
							{window.room.started ? 'Game In Progress, ' : ''}
							You Are Waiting To Play
						</WaitingStatus>
					</div>
				) : (
					<div className="game-swf-object">
						{!is_video(this.props.room.users[0].image) ? (
							<img
								className="videodj-img-anything"
								onClick={this.banner}
								src={profile_picture(this.props.room.users[0].image)}
							/>
						) : (
							<img
								className="videodj-img-anything"
								onClick={this.banner}
								src={profile_picture(this.props.room.users[0].image).replace(/\.[^\.]+$/, '.png')}
							/>
						)}

						<GameWatchanythingPlayer
							player="1"
							room={this.props.room}
							data={this.props.room.round.data ? this.props.room.round.data[1] : {}}
						/>
					</div>
				)}
			</div>
		)
	},
	banner: function () {
		var x = document.getElementsByClassName('banner')[0]
		var y = document.getElementsByClassName('iframe')[0]
		if (x.style.display === 'none') {
			x.style.display = 'block'
			y.style.height = '98%'
		} else {
			x.style.display = 'none'
			y.style.height = '100%'
		}
	},
	muted: function () {
		var o = storage.get()
		return o.muted ? true : false
	},
	getUsers: function () {
		return window.room.users
	},

	host: function () {
		return (
			window.room &&
			window.room.users &&
			window.room.users[0] &&
			window.room.users[0].id == window.user.id
		)
	},
	me: function () {
		var o = u.copy(window.user)
		if (is_video(o.image)) o.image = profile_picture(o.image).replace(/\.[^\.]+$/, '.png')
		else o.image = profile_picture(o.image)
		return o
	},
	meRoom: function () {
		for (var id in window.room.users) {
			if (window.room.users[id].id == window.user.id) {
				var o = u.copy(window.room.users[id])
				if (is_video(o.image)) o.image = profile_picture(o.image).replace(/\.[^\.]+$/, '.png')
				else o.image = profile_picture(o.image)
				return o
			}
		}

		return {}
	},
	start: function () {
		if (this.host() || window.user.mod || window.user.pu) {
			emit({
				id: 'room update',
				started: true,
			})
		}
	},
	stop: function () {
		if (this.host()) {
			emit({
				id: 'room update',
				started: false,
			})
		} else if (window.user.mod || window.user.pu) {
			CONFIRM('Are you Sure?', function () {
				emit({
					id: 'room update',
					started: false,
				})
			})
		}
	},
	end: function () {
		if (this.host() || window.user.mod || window.user.pu) {
			emit({
				id: 'room update',
				end: true,
			})
		}
	},
})

var GameWatchanythingPlayer = React.createClass({
	mixins: [React.addons.PureRenderMixin],
	getInitialState: function () {
		window.loadLocation = this.loadLocation
		return {}
	},
	loadLocation: function (e) {
		// this.setState({ link: e.target.href })
		if (this.host()) {
			emit({ id: 'awts', link: e.target.href })
		}
	},
	render: function () {
		var results = this.state.results || []
		var queue = this.state.queue || []
		var related = this.props.data && this.props.data.related ? this.props.data.related : []
		setTimeout(
			function () {
				this.firstTime = false
			}.bind(this),
			0,
		)
		return (
			<div
				className={
					'full-height' +
					(this.state.maximize ||
					(this.firstTime && this.props.player === '1' && (this.state.maximize = true))
						? ' maximize '
						: '')
				}
			>
				<div align="center" className="banner" height="2%">
					<h5
						href={
							this.props.room.round.data && this.props.room.round.data.link
								? this.props.room.round.data.link
								: ''
						}
					>
						{' '}
						{this.props.room.round.data && this.props.room.round.data.link
							? this.props.room.round.data.link
							: ''}{' '}
					</h5>
				</div>
				<iframe
					src={
						this.props.room.round.data && this.props.room.round.data.link
							? this.props.room.round.data.link
							: null
					}
					width="100%"
					className="iframe"
					height="98%"
					scrolling="yes"
					frameborder="0"
					allowfullscreen
					allowtransparency
					referrerpolicy="unsafe-url"
					Content-Security-Policy="frame-ancestors 'self'"
					X-Frame-Options="ALLOW-FROM ALL"
					allow="encrypted-media"
				></iframe>
			</div>
		)
	},
	maximize: function () {
		this.setState({
			maximize: !this.state.maximize,
		})
	},
	getUsers: function () {
		var oa = []

		for (var id in window.room.users) {
			var o = u.copy(window.room.users[id])
			if (is_video(o.image)) o.image = profile_picture(o.image).replace(/\.[^\.]+$/, '.png')
			else o.image = profile_picture(o.image)
			oa[id] = o
		}
		return oa
	},

	host: function () {
		return (
			window.room &&
			window.room.users &&
			window.room.users[0] &&
			window.room.users[0].id == window.user.id
		)
	},
	me: function () {
		return window.user
	},
	meRoom: function () {
		for (var id in window.room.users) {
			if (window.room.users[id].id == window.user.id) {
				var o = u.copy(window.room.users[id])
				if (is_video(o.image)) o.image = profile_picture(o.image).replace(/\.[^\.]+$/, '.png')
				else o.image = profile_picture(o.image)
				return o
			}
		}

		return {}
	},

	start: function () {
		if (this.host() || window.user.mod || window.user.pu) {
			emit({
				id: 'room update',
				started: true,
			})
		}
	},
	stop: function () {
		if (this.host()) {
			emit({
				id: 'room update',
				started: false,
			})
		} else if (window.user.mod || window.user.pu) {
			CONFIRM('Are you Sure?', function () {
				emit({
					id: 'room update',
					started: false,
				})
			})
		}
	},
	end: function () {
		if (this.host() || window.user.mod || window.user.pu) {
			emit({
				id: 'room update',
				end: true,
			})
		}
	},
})
